export default __webpack_public_path__ + "static/media/online-survay.b2f47685.svg";